import React from 'react'

/* Component for showing tooltip over mouse. */
export default class Tooltip extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            width: 0,
            height: 0,
            ref: React.createRef(),
        }
    }

    componentDidUpdate() {
        /* Fetch state variables. */
        const { width, height, ref } = this.state
        /* Check if reference is active. */
        if (ref.current) {
            /* Fetch current dimensions. */
            const currWidth = ref.current.getBoundingClientRect().width
            const currHeight = ref.current.getBoundingClientRect().height
            /* Update dimensions if it does not match. */
            if (currWidth !== width || currHeight !== height) {
                this.setState({
                    width: currWidth,
                    height: currHeight
                })
            }
        }
    }

    render() {
        /* Fetch prop variables. */
        const { position, name, data } = this.props
        /* Fetch state variables. */
        const { width, height, ref } = this.state
        /* Render. */
        return (
            this.props.name !== null &&
            <div 
                className="map-tooltip p-3 text-center"
                ref={ref}
                style={{
                    /* Try to position top right, switch if out of border. */
                    left: (position.left + width < window.innerWidth) ? (position.left) : (position.left - width),
                    top: (position.top + height < window.innerHeight) ? (position.top) : (position.top - height),
                }}
            >
                <span className="font-weight-bold">{name}</span>
                <br/>
                <span> <span className="font-weight-bold">Confirmed: </span> {data?.confirmed.toLocaleString() || 0} </span>
                <br/>
                <span> <span className="font-weight-bold">Deaths: </span> {data?.deaths.toLocaleString() || 0} </span>
            </div>
        )
    }
}
